export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8419.bf81ef04.jpg";